import { gql, TypedDocumentNode } from '@common/hooks';
import {
  SupplierByEmailDomainQueryCgResponse,
  SupplierByEmailDomainQueryVariables,
} from '@common/graphql/schema';

export const SUPPLIER_BY_EMAIL_DOMAIN_QUERY: TypedDocumentNode<
  SupplierByEmailDomainQueryCgResponse,
  SupplierByEmailDomainQueryVariables
> = gql`
  query SupplierByEmailDomain($email: String!) {
    supplierByEmailDomain(email: $email) {
      type
      id
      name
    }
  }
`;
